import { AppMainComponent } from './../../../../app.main.component';
import { Component, Input, OnChanges, SimpleChange, SimpleChanges } from "@angular/core";

// Service and Helpers
import { AppMainService } from "src/app/app-main.service";
import { CustomAttributeService } from "../../services/custom-attribute.service";
import { FileService } from "../../services/file.service";
import { MessageService } from "primeng/api";
import { uploadFiles, validateFiles, validateFileSize } from 'src/app/shared/upload-files';
import { CurrencyService } from '../../services/currency.service';

@Component({
    selector: 'app-shared-custom-fields-template',
    templateUrl: './shared-custom-fields-template.component.html',
})

export class SharedCustomFieldsTemplateComponent implements OnChanges {
    @Input() selectedCustomFields = [];
    @Input() isSubmitted: boolean = false;
    @Input() tabIndex: number = 0;

    allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
    usersList: any[] = [];

    currencySymbol: string = "";
    multiLineTooltipPicture = `<ul class="p-mt-0 p-pl-4 p-mb-0">
        <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
        <li>Files size should not be more than 2MB</li>
    </ul>`;
    multiLineTooltipFile = `<ul class="p-mt-0 p-pl-4 p-mb-0">
      <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
      <li>Files size should not be more than 2MB</li>
    </ul>`;

    constructor(
        private app: AppMainComponent,
        private appMainService: AppMainService,
        private customAttributeService: CustomAttributeService,
        private fileService: FileService,
        private currencyService: CurrencyService,
        private messageService: MessageService
    ) {
        this.usersList = this.app.usersList;
        this.currencySymbol = this.currencyService.currencySymbolValue;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.selectedCustomFields?.currentValue){
            // console.log(changes.selectedCustomFields?.currentValue)
        }
    }

    onCustomUpload(event, field, type) {
        field.customeAttachement = field.customeAttachement || [];
        field['touched'] = true;

        for (let file of event.files) {
            let errors = [];

            this.appMainService.isShowSpinner('upload');

            if (type == 'image') {
                errors = validateFiles(file, 2, this.allowedExtensions);
            }else{
                errors = validateFileSize(file, 2);
            }

            if (errors.length) {
                for (let error of errors) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.fileName + ": " + error.error
                    });
                }

                this.appMainService.isHideSpinner('upload');
            } else {
                uploadFiles(file, ({ name, content, size, extension }) => {
                    let attachment = {
                        "name": name,
                        "content": content,
                        "extension": extension,
                        "sizeInBytes": size,
                    };

                    field.customeAttachement.push(attachment);

                    this.appMainService.isHideSpinner('upload');
                });
            }
        }
    }

    downloadFile(name, content): void {
        this.fileService.downloadFile(name, content);
    }

    removeImg(index, field) {
        field.customeAttachement.splice(index, 1);
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    clearEncryptedText(field: any){
        if(!field?.oldValueCleared){
            field.oldValueCleared = true;
            field.value = "";
        }
    }
}
